import { render, staticRenderFns } from "./AgentDeposit.vue?vue&type=template&id=bd67a59e"
import script from "./AgentDeposit.vue?vue&type=script&lang=js"
export * from "./AgentDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports